export default __webpack_public_path__ + "static/media/2014.84a23daf.png";